import actionTypes from "../actionTypes";

export const handleDraggableModalState = payload => ({
  type: actionTypes.DRAGGABLE_MODAL_STATE,
  payload
});
